<template>
  <div class="introduce">
    <div class="title"><v-icon>map</v-icon>상품 소개서</div>
    <div class="items_wrapper">
      <div class="introduce_items" id="introduce_items_1">
        <img src="static/img/interworksmedia.png" class="down_img" alt="인터웍스 매체 소개서" />
        <img src="static/img/interplay.png" class="down_img" alt="인터플레이 상품 소개서" />
        <div class="down_wrap">
          <a :href="iw" download>
            <span :title="msg_1.a">인터웍스미디어 통합소개서</span>
            <div :title="msg_1.a" class="down_btn">
              <img src="static/img/down-icon.png" alt="down"/>
            </div>
          </a>
          <a :href="iwCase2" download>
            <span :title="msg_1.a">2022인터플레이 상품소개서</span>
            <div :title="msg_1.a" class="down_btn">
              <img src="static/img/down-icon.png" alt="down"/>
            </div>
          </a>
          <a :href="iwCase" download>
            <span :title="msg_1.b">집행사례</span>
            <div :title="msg_1.b" class="down_btn">
              <img src="static/img/down-icon.png" alt="down"/>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as url from '@/assets/links'
  export default {
    name: 'introduce',
    data () {
      return {
        msg_1: {
          a: '인터웍스 상품소개서 다운로드',
          b: '인터웍스 집행사례 다운로드'
        },
        msg_2: {
          a: '인터플레이 상품소개서 다운로드',
          b: '인터플레이 집행사례 다운로드'
        }
      }
    },
    computed: {
      iw () {
        return url.iw
      },
      iwCase () {
        return url.iwCase
      },
      iwCase2 () {
        return url.iwCase2
      }
      // },
      // ip () {
      //   return url.ip
      // },
      // ipCase () {
      //   return url.ipCase
      // }
    }
  }
</script>

<style scoped>
  .introduce .title {
    margin-left: 10px;
    height: 30px;
    line-height: 30px;
    color: #689f38;
    font-weight: 500;
  }
  .title i {
    vertical-align: middle;
    margin-right: 5px;
  }

  .items_wrapper {
    width: calc(100% - 10px);
    padding-right: 10px;
    padding-top: 5px;
    margin: 0 auto;
  }
  .introduce_items {
    display: inline-block;
    width: calc(100% - 12px);
    margin-left: 10px;
    margin-bottom: 10px;
    padding-top: 5px;
    border: 1px solid #dae8f1;
    border-radius: 6px;
    /* background: #e2f0d9; */
  }
  .down_img {
    height: 30px;
    width: auto;
    margin-left: 5px;
  }
  .down_wrap {
    text-align: right;
    font-size: 11pt;
    font-weight: 500;
  }
  .down_wrap span {
    margin-right: 3px;
  }
  .down_btn img {
    width: 20px;
  }
  .down_btn {
    display: inline-block;
    height: 20px;
    vertical-align: middle;
    margin-bottom: 4px;
    margin-right: 7px;
    padding-top: 1px;
    padding-bottom: 1px;
  }
  @media screen and (max-width: 500px) {
    .introduce_items {
      width: calc(100% - 10px);
    }
  }
  @media screen and (max-width: 350px) {
    .introduce_items i {
      font-size: 15pt;
    }
  }
</style>



// WEBPACK FOOTER //
// Introduce.vue?38ea1760